import { Button, type ButtonProps } from "@tosize/ui";
import { FormattedMessage } from "react-intl";

interface NavigationProps {
	prev?: Pick<ButtonProps, "isLoading" | "onClick" | "title">;
	next?: Pick<ButtonProps, "isLoading" | "onClick" | "title">;
}

export default function Navigation({ prev, next }: NavigationProps) {
	return (
		<div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 pt-3">
			{prev && (
				<Button variant="contained" size="small" {...prev}>
					{prev.title ?? <FormattedMessage defaultMessage="Vorige" id="5FuA/J" />}
				</Button>
			)}
			{next && (
				<Button variant="contained" size="small" {...next}>
					{next.title ?? <FormattedMessage defaultMessage="Volgende" id="13MUCY" />}
				</Button>
			)}
		</div>
	);
}
